import React, { useContext } from "react";
import { useAuth } from "../context/AuthContext";
import { ChildProgressContext } from "../context/ChildProgressContext";
import { useActivity } from "../context/ActivityContext";
import "./Profile.css";

const Profile = () => {
    const { currentUser } = useAuth();
    const { progress } = useContext(ChildProgressContext);
    const { activities } = useActivity();

    // Example recent activities (you can later store these in Firebase)
    // Take latest 5 activities
    const recentActivities = activities.slice(-5).reverse();

    const last5Days = [
        { day: "Today", activity: "Addition Practice", stars: 2 },
        { day: "Yesterday", activity: "Alphabets Learning", stars: 1 },
        { day: "2 Days Ago", activity: "Coloring Activity", stars: 1 },
        { day: "3 Days Ago", activity: "Tables Practice", stars: 2 },
        { day: "4 Days Ago", activity: "Brain Game", stars: 1 }
    ];

    return (
        <div className="profile-page">

            <h1 className="profile-title">👦 Child Learning Profile</h1>

            {/* User Info */}
            <div className="profile-card">
                <h2>User Information</h2>
                <p><strong>Email:</strong> {currentUser?.email}</p>
                <p><strong>Total Stars Earned:</strong> ⭐ {progress.stars}</p>
            </div>

            {/* Learning Summary */}
            <div className="profile-card">
                <h2>📚 Learning Summary</h2>
                <ul>
                    <li>Alphabets Learning</li>
                    <li>Numbers Practice</li>
                    <li>Multiplication Tables</li>
                    <li>Shapes Recognition</li>
                    <li>Color Identification</li>
                    <li>Math Practice (Addition, Subtraction, etc.)</li>
                </ul>
            </div>

            {/* Recent Activity */}
            <div className="profile-card">
                <h2>🕒 Recent Activity</h2>

                {recentActivities.length === 0 ? (
                    <p>No activities yet</p>
                ) : (
                    recentActivities.map((item, index) => (
                        <div key={index} className="activity-item">

                            {/* Activity Name */}
                            <span>
                                {item.activity}
                            </span>

                            {/* Time */}
                            <span className="time">
                                {item.time || new Date(item.date).toLocaleTimeString()}
                            </span>

                        </div>
                    ))
                )}
            </div>

            {/* Last 5 Days History */}
            <div className="profile-card">
                <h2>📅 Last 5 Days Learning History</h2>
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>Day</th>
                            <th>Activity</th>
                            <th>Stars Earned</th>
                        </tr>
                    </thead>

                    <tbody>
                        {last5Days.map((day, index) => (
                            <tr key={index}>
                                <td>{day.day}</td>
                                <td>{day.activity}</td>
                                <td>⭐ {day.stars}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default Profile;